import { Component, OnInit, Inject,OnDestroy, ViewEncapsulation } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { StaffService } from '../staff.service';
import { AuthorizeList,  StaffForCreationResponse, DeleteStaff, getNotifyStaffRole, getAlertByStaffId} from '../staff';
import {appsettings} from '../../../app-settings';
import { Http } from '@angular/http';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage,AuthFailedMessage } from '../../../app-general';
import {Router} from '@angular/router';
import { ApiService } from '../../../api.service';
import { takeUntil } from 'rxjs/operators';
import { checkAlertForTag } from '../../../api';

@Component({
  selector: 'app-delete-staff',
  templateUrl: './delete-staff.component.html',
  providers: [ StaffService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./delete-staff.component.scss']
})
export class DeleteStaffComponent implements OnInit,OnDestroy {

  watcher: Subscription;
  columns: number = 3;
  public staffDeleteForm : FormGroup;
  private URL = appsettings.URLinfo+'getAuthorizer';
  public staffAuthorized : AuthorizeList[];
  currentDate;
  staffname;
  DesignationId=0;
  authorizedName;
  staffTagid=0;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,private staffService: StaffService,public thisDialogRef: MatDialogRef<DeleteStaffComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService,public dialog: MatDialog,
  private http:Http) {
      this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
        if (change) {         
          if (change.mqAlias == 'xs') {
            this.columns = 2;
          } 
          else if (change.mqAlias == 'sm') {
            this.columns = 3;
          } 
          else
          {
            this.columns = 3;
          }                
        }
      });   
      this.staffname = data[0].FirstName + " " + data[0].LastName; 
      if (data[0].DesignationId!="")
      this.DesignationId = parseInt(data[0].DesignationId); 
      if (data[0].TagId!="")
        this.staffTagid=parseInt(data[0].TagId);
   }

  ngOnInit() {
    this.getAuthorizedList();
      this.currentDate = new Date().toJSON("yyyy/MM/dd");
      this.staffDeleteForm = new FormGroup({
      staffname: new FormControl('', [Validators.required, Validators.maxLength(60), Validators.pattern(appsettings.Name_Pattern)]),
      staffId: new FormControl(''),
      date : new FormControl(''),      
      staffreason : new FormControl('', [Validators.required, Validators.pattern(appsettings.Name_Pattern)]),
      authorizedby : new FormControl('', [Validators.required]),
        });
      this.staffDeleteForm.get('staffname').disable();
      this.staffDeleteForm.get('date').disable();
      this.staffDeleteForm.get('authorizedby').disable();
  }

  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.staffDeleteForm.controls).forEach(field => { // {1}
        const control = this.staffDeleteForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('delete-staff.component.ts' + ' - handleInput() - ' + err.message);
    }
  }

  public onCloseCancel = () => {
    
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }

  getAuthorizedList()
  {    
    try
    {
      this.authorizedName = JSON.parse(localStorage.getItem("username"));
    }
    catch (err) {
      throw new Error('delete-staff.component.ts' + ' - getAuthorizedList() - ' + err.message);
    }
  } 

  
  public deleteStaffbyId = (deleteFormValue) => {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }     
       if (this.staffDeleteForm.valid) {      
            var alerttagidfoundItem : checkAlertForTag = 
            {
              siteId:this.SiteId, 
              authKey: localStorage.getItem("Authkey"),
              oldTagId: this.staffTagid,
              isResStaff: 0 
            }
            this.apiService.checkAlertForTag(alerttagidfoundItem).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : any[])=>{              
              if(apiresponse.toString() == "not found")
              {
                this.getStaffRole(deleteFormValue); 
              }
              else
              {
                generateAlertMessage(this.dialog, 'The staff '+ this.staffname + ' has open alerts, please complete or cancel those alerts and try again.')                
                this.thisDialogRef.close('Close'); 
                return;
              }
    
            });
        }            
                   
  }  

  getStaffRole(deleteFormValue)
  {
    try
    {               
        var RolefoundItem : getNotifyStaffRole = { 
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          role: (this.DesignationId), 
          staffId: parseInt(deleteFormValue.staffId) 
        }        
        this.staffService.getStaffRole(RolefoundItem).pipe(takeUntil(this._onDestroy))        
        .subscribe((apiroleresponse : any[])=>{                       
          if (apiroleresponse !=null && apiroleresponse !=undefined)
          {   
            if(apiroleresponse.toString() == "Success")
            {
              this.getAcceptAndPresenceAlertsByStaffId(deleteFormValue);             
            }
            else
            {   
              generateAlertMessage(this.dialog, 'This '+apiroleresponse[0].Designation+' is in escalation level, so please remove this role from escalation and try again.')                                     
            }
          }
          else
          {
            generateAlertMessage(this.dialog, 'Staff creation failed !')            
          }
        });
      }    
    catch (err) {
      throw new Error('delete-staff.component.ts' + ' - getStaffRole() - ' + err.message);
    }
  }

  private getAcceptAndPresenceAlertsByStaffId = (releaseFormValue) => {
    try
    {
      var staffid : getAlertByStaffId = 
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        staffId: parseInt(releaseFormValue.staffId)
      }                   
      this.staffService.getAcceptAndPresenceAlertsByStaffId(staffid).pipe(takeUntil(this._onDestroy))
    .subscribe((alertdata : any)=>
    {               
      if(alertdata.toString() == "not found")
      {
          this.deleteStaffData(releaseFormValue)
      }
      else
      {
          if(alertdata.toString() == "Staff in Alert")
          {
            generateAlertMessage(this.dialog, "This staff " +  this.staffname + " has accepted alerts and not completed. Upon releasing, please <br> complete or cancel those alerts and try again.?");
          }
          else if(alertdata.toString() == "Staff in Notification")
          {
            generateAlertMessage(this.dialog, "This " +  this.staffname + " is in escalation level. so please remove this <br> staff from the escalation and try again.");            
          }
         
          this.thisDialogRef.close('Close');        
      }
    });         
    }
    catch (err) {
      throw new Error('delete-staff.component.ts' + ' - getAcceptAndPresenceAlertsByStaffId() - ' + err.message);
    }

  }


deleteStaffData(releaseFormValue)
{
    try
    {
      var userid = localStorage.getItem("userid");   
      let deleteStaff: DeleteStaff = {          
        authKey: localStorage.getItem("Authkey"),  
        reason : releaseFormValue.staffreason.replace(/\s+/g, ' ').trim(),
        authorizedBy : parseInt(localStorage.getItem("userid")),
        staffId : parseInt(releaseFormValue.staffId),
        }      
        
        this.staffService.deleteStaffData(deleteStaff).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : StaffForCreationResponse[])=>
          {    
    
            if (apiresponse!=null && apiresponse!=undefined)
            {     
              if(apiresponse["apiReturn"] == "Success")
              { 	                
                this.apiService.reloadStaff();
                generateAlertMessage(this.dialog, 'Staff data deleted successfully.')                
              }     
              else if(apiresponse["apiReturn"] == "Fail")
              {
                generateAlertMessage(this.dialog, 'Staff data deleted failed.')                
              }
              else if(apiresponse["apiReturn"] == "Main")
              {
                generateAlertMessage(this.dialog, 'Super user could not allowed to delete.')                
              }
              else if(apiresponse["apiReturn"] == "Invalid Auth Key")
              { 
                this.thisDialogRef.close('close');                                  
                AuthFailedMessage(this.dialog,this.router);  
                return;       
              }  
            }
            else
            {
              generateAlertMessage(this.dialog, 'Staff data deleted failed.')              
            }
          this.thisDialogRef.close('Confirm');        
          });
    
    }
    catch (err) {
      throw new Error('delete-staff.component.ts' + ' - deleteStaffData() - ' + err.message);
    }

  }

 
   ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
